import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import about from "@/views/about.vue";
import solution from "@/views/solution/solution.vue";
import voice from "@/views/solution/voice.vue";
import custom from "@/views/solution/custom.vue";
import doc from "@/views/sdk/docs.vue";
import androidBluetoothSdk from "@/views/sdk/Android/android-bluetooth-sdk.vue";
import androidVoiceCompressSdk from "@/views/sdk/Android/android-voice-compress-sdk.vue";
import iosBluetoothSdk from "@/views/sdk/IOS/ios-bluetooth-sdk.vue";
import product from "@/views/product/product.vue";
import compress from "@/views/product/compress.vue";
import voicechip from "@/views/product/voicechip.vue";
import sdk from "@/views/product/sdk.vue";
import operate from "@/views/product/operate.vue";
import applyCard from "@/views/product/applyCard.vue";
import pic from "@/views/product/pic.vue";
import pc from "@/views/pc/pc.vue"; 
import bdsystem from "@/views/pc/bd3command.vue";
import bdsystemPro from "@/views/pc/bdsystemPro.vue";
import protocolParsingTool from "@/views/pc/protocolParsingTool.vue";
import bdtest from "@/views/pc/bd3test.vue";
import bdsdk from "@/views/sdk/sdk.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    alias: ["/login"],
  },
  {
    path: "/about",
    name: "about",
    component: about,
  },
  {
    path: "/solution",
    name: "solution",
    component: solution,
    children: [
      {
        path: "voice",
        name: "voice",
        component: voice,
      },
      {
        path: "custom",
        name: "custom",
        component: custom,
      },
    ],
  },

  {
    path: "/product",
    name: "product",
    component: product,
    children: [
      {
        path: "voicechip",
        name: "voicechip",
        component: voicechip,
      },
      {
        path: "compress",
        name: "compress",
        component: compress,
      },
      {
        path: "pic",
        name: "pic",
        component: pic,
      },
      {
        path: "sdk",
        name: "sdk",
        component: sdk,
      },
      {
        path: "operate",
        name: "operate",
        component: operate,
      },
      {
        path: "applyCard",
        name: "applyCard",
        component: applyCard,
      },
    ],
  },
  {
    path: "/api",
    name: "bdsdk",
    component: bdsdk,
    children: [
      {
        path: "Android/android-bluetooth-sdk",
        name: "api-android-bluetooth-sdk",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: androidBluetoothSdk,
      },
      {
        path: "Android/android-voice-compress-sdk",
        name: "api-android-voice-compress-sdk",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: androidVoiceCompressSdk,
      },
      {
        path: "Android/:nameEn",
        name: "api-android",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: doc,
      },
      {
        path: "pc/:nameEn",
        name: "api-pc",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: doc,
      },
      {
        path: "IOS/ios-bluetooth-sdk",
        name: "api-ios-bluetooth-sdk",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: iosBluetoothSdk,
      },
      {
        path: "web/:nameEn",
        name: "api-web",
        meta: {
          showBg: true,
          name: "docs",
        },
        component: doc,
      },
    ],
  },

  {
    path: "/pc",
    name: "pc",
    component: pc,
    children: [
      {
        path: "bdtest",
        name: "bdtest",
        component: bdtest,
      },
      {
        path: "bdsystem",
        name: "bdsystem",
        component: bdsystem,
      },
      {
        path: "bdsystemPro",
        name: "bdsystemPro",
        component: bdsystemPro,
      },
      {
        path: "protocolParsingTool",
        name: "protocolParsingTool",
        component: protocolParsingTool,
        meta: {
          showBg: true,
          name: "docs",
        },
      },
    ],
  },

  {
    path: "/privacy",
    name: "隐私政策",
    component: () => import('@/views/privacy/index'),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to, from, next) => {
  if (to.path != '/privacy') {
    setTimeout(() => {
      var _hmt = _hmt || [];
      (function () {
        //每次执行前，先移除上次插入的代码
        document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?a78e84cd7b0772e3e554f63d497ed37d";
        hm.id = "baidu_tj"
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
    }, 0);
  }
});

export default router;
